import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { RouterModule } from '@angular/router';
import { ContentFacade } from '@thiememeulenhoff/ng-store';
import { ThasService, UserActivityService } from '../features/admin/services';
import { environment } from '../environments/environment';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [RouterModule],
  selector: 'edu-root',
  template: `<router-outlet></router-outlet>`,
})
export class AppComponent {
  readonly #contentFacade = inject(ContentFacade);

  readonly #userActivityService = inject(UserActivityService);

  readonly #thasService = inject(ThasService);

  constructor() {
    this.#userActivityService.initialize();
    this.#thasService.initialize();

    if (environment.localParsingEnabled) {
      this.#contentFacade.enableLocalParsing();
    }
  }
}
